// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"552":"efc67a3b","870":"a1cb41d2"}[chunkId] + ".css";
};